import React, { useState } from 'react';
import { ApChip } from '@alixpartners/ui-components';
import { FilterMenuContentDebounced } from 'components/NavFilter';
import { CounterWrapper, StyledMenu } from './components.styles';

const MultiSelect = props => {
	const {
		label,
		name,
		onChange,
		options,
		selected,
		disabled,
		isLoading,
	} = props;

	const [isOpen, setOpen] = useState(false);
	const [showVirtualList, setShowVirtualList] = useState(false);

	const toggleMenu = open => {
		setOpen(open);
	};
	const selectedCount = (selected && selected.length) || 0;

	return (
		<StyledMenu
			button={
				<div style={{ width: 'fit-content', position: 'relative' }}>
					{!!selectedCount && (
						<>
							<CounterWrapper>
								<>{selectedCount}</>
							</CounterWrapper>
						</>
					)}

					<ApChip
						small
						selected={isOpen || !!selectedCount}
						disabled={disabled}
					>
						{isLoading ? 'Loading' : <span>{label || name}</span>}
					</ApChip>
				</div>
			}
			placement="left-end"
			toggleMenu={toggleMenu}
			isOpen={isOpen}
			isVirtualList={showVirtualList}
			disabled={disabled}
		>
			<FilterMenuContentDebounced
				setShowVirtualList={setShowVirtualList}
				options={options}
				onChange={onChange}
				selected={selected}
				isOpen={isOpen}
			/>
		</StyledMenu>
	);
};

export default MultiSelect;
